// extracted by mini-css-extract-plugin
export default {"list":"style_list__Zpj+Y","container":"style_container__WE6+T","left":"style_left__YfDV7","right":"style_right__zgQaz","avatar":"style_avatar__7rZhR","logo":"style_logo__j8V0w"};